import type { Offer } from '@fourthwall/services/dist/models/offer'

import type { Product } from './types'

export const getIdsOfAdjacentElements = (
  products: Product[],
  oldIndex: number,
  newIndex: number,
) => {
  const before = newIndex ? undefined : products[newIndex].id
  const after = newIndex ? products[newIndex - (oldIndex > newIndex ? 1 : 0)].id : undefined

  return { before, after }
}

export const getCurrentProductPositionIndex = (
  offerId: Offer.Id,
  products: Product[],
  currentPage: number,
  pageSize: number,
) => {
  const index = products.findIndex((product) => product.id === offerId) + 1

  return pageSize * (currentPage - 1) + index
}

export const getUpdatedProductPositionIndex = (
  type: 'TOP' | 'BOTTOM' | 'EXACT',
  updatedIndex: number,
  totalProductsCount: number,
) =>
  ({
    TOP: 0,
    BOTTOM: totalProductsCount - 1,
    EXACT: updatedIndex - 1,
  })[type]
